import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'FileSize',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props

const byteValueNumberFormatter = Intl.NumberFormat('en', {
  notation: 'compact',
  style: 'unit',
  unit: 'byte',
  unitDisplay: 'narrow'
})

return (_ctx: any,_cache: any) => {
  return _toDisplayString(props.value !== undefined ? _unref(byteValueNumberFormatter).format(props.value) : '')
}
}

})